/**
 * CP-103: Browse must not paint the previous page under a new filter.
 *
 * A line chip updates the active filters before /api/cruises returns. The
 * previous rows stay in memory so a slow or failed follow-up cannot wipe a
 * good load (that clear-at-start path flashed 20 results, then empty).
 * Those rows are shown only when they were fetched for the filters now in
 * effect. While a Holland America apply is in flight, an unfiltered page
 * of NCL/MSC cards is not current and stays hidden behind the loader.
 */

export function filterSignature(filters) {
  const src = filters && typeof filters === 'object' ? filters : {};
  return JSON.stringify(Object.keys(src).sort().map((key) => [key, src[key]]));
}

export function browseListIsCurrent(activeFilters, committedSignature) {
  if (committedSignature == null) return false;
  return filterSignature(activeFilters) === committedSignature;
}
